// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ff9bc105","113":"a959eb82","136":"d7a5a2db","181":"c308e9e0","198":"fa39ab4e","439":"99c53f5b","481":"70d8ee0b","485":"58bc0132","488":"371f7511","562":"b85d128f","700":"1c6ced16","721":"d0b73063","746":"691d65a1","941":"d801205e"}[chunkId] + ".chunk.js";
};